<template>
    <page showBackButton>
        <h1>Video Meeting Terminanfrage</h1>
        <ion-card>
            Reserviere dir online einen Termin bei einem Berater in deiner Nähe
            und stell deine Fragen bequem von zuhause aus in einem Video Call.
        </ion-card>
        <base-input
            type="text"
            :value="finalAgentName || agentId"
            label="Anfrage an"
            id="agentName"
            disabled
        ></base-input>
        <base-input
            type="text"
            v-model="product"
            label="Dein Produkt"
            id="contract"
            v-if="product !== ''"
        ></base-input>
        <template
            v-if="
                !$store.state.isLoggedIn ||
                Object.keys($store.state.user.details).length === 0
            "
        >
            <base-select id="anrede" v-model="formData.anrede" label="Anrede">
                <ion-select-option value="Herr">Herr</ion-select-option>
                <ion-select-option value="Frau">Frau</ion-select-option>
            </base-select>

            <base-input
                type="text"
                v-model="formData.titel"
                label="Titel"
                id="titel"
            ></base-input>

            <base-input
                type="text"
                v-model="formData.vorname"
                label="Vorname"
                id="vorname"
            ></base-input>

            <base-input
                type="text"
                v-model="formData.zuname"
                label="Zuname"
                id="zuname"
            ></base-input>
        </template>
        <base-input
            type="email"
            v-model="formData.email"
            label="Deine E-Mail Adresse"
            id="email"
        ></base-input>
        <base-input
            type="tel"
            v-model="formData.telefon"
            label="Deine Telefonnummer"
            id="telefon"
        ></base-input>
        <base-textarea
            id="nachricht"
            v-model="formData.nachricht"
            label="Nachricht"
            :rows="4"
            class="ion-margin-bottom"
        ></base-textarea>
        <ion-list>
            <ion-list-header>
                <ion-label>Gewünschtes Datum und Zeitfenster</ion-label>
            </ion-list-header>
            <base-datetime
                label="Datum"
                v-model="formData.rueckruf_datum"
                id="rueckruf_datum"
                :showNativeInput="true"
                placeholder="TT.MM.JJJJ"
                infoText="Das Datum muss im Format TT.MM.JJJJ eingegeben werden."
                isFuture
            ></base-datetime>
            <base-datetime
                label="Von"
                v-model="von"
                id="von"
                displayFormat="HH:mm"
                pickerFormat="HH:mm"
            ></base-datetime>
            <base-datetime
                label="Bis"
                v-model="bis"
                id="bis"
                displayFormat="HH:mm"
                pickerFormat="HH:mm"
                :minDate="bisMin"
            ></base-datetime>
        </ion-list>
        <ion-button expand="block" @click="submitForm()"
            >Termin anfragen</ion-button
        >
    </page>
</template>

<script>
import Page from "@/components/Page";
import BaseInput from "@/components/BaseInput";
import { isLoggedIn } from "../api/auth";
import BaseDatetime from "@/components/BaseDatetime";
import { replaceAt } from "@/utils/string";
import { coachContact } from "@/api/coachcontact";
import BaseTextarea from "@/components/BaseTextarea";
import { DateFormatter } from "@/utils/date";
import BaseSelect from "@/components/BaseSelect";
import { handleError } from "../utils/error";

export default {
    components: {
        Page,
        BaseInput,
        BaseDatetime,
        BaseTextarea,
        BaseSelect,
    },
    props: {
        agentId: {},
        agentName: {},
        contractId: {
            required: false,
            type: String,
            default: "",
        },
        motive: {
            required: false,
            type: String,
            default: "allgemein",
        },
    },
    data() {
        return {
            product: "",
            formData: {
                bereich: "",
                anrede: "",
                titel: "",
                vorname: "",
                zuname: "",
                email: "",
                telefon: "",
                nachricht: "",
                plznocheck: true,
                rueckruf: 1,
                video: 1,
                rueckruf_datum: "",
                rueckruf_anmerkung: "",
            },
            von: "",
            bis: "",
            bisMin: undefined,
            finalAgentName: undefined,
        };
    },
    watch: {
        von(value) {
            this.bisMin = replaceAt(
                value,
                11,
                parseInt(value.substring(11, 13)) + 2
            );
            if (value !== "" && this.bis !== "") {
                const vonHour = value.substring(11, 13);
                const bisHour = this.bis.substring(11, 13);
                if (bisHour - vonHour < 2) {
                    this.bis = "";
                }
            }
        },
    },
    mounted() {
        this.$store.commit("setLoading", true);
        isLoggedIn()
            .then(() => {
                // this.$store.commit("setLoading", true);
                this.$store.cache.dispatch("user/getUserAddress").then(() => {
                    let userdetails = this.$store.state.user.details;
                    if (Object.keys(userdetails).length > 0) {
                        this.formData.anrede = userdetails.geschlecht;
                        this.formData.titel = userdetails.titel;
                        this.formData.vorname = userdetails.vorname;
                        this.formData.zuname = userdetails.nachname;
                        this.formData.email = userdetails.email;
                        this.formData.telefon = userdetails.telefon;
                        this.formData.plz = userdetails.plz;
                    }
                });
                this.formData.bereich = this.motive;
                let productText = "";
                const contracts = this.$store.state.contracts;
                if (contracts[this.contractId]) {
                    if (contracts[this.contractId].Name) {
                        productText += contracts[this.contractId].Name + " ";
                    }
                    if (contracts[this.contractId].ContractIdFormatted) {
                        productText +=
                            "(" +
                            contracts[this.contractId].ContractIdFormatted +
                            ")";
                    }
                }
                this.product = productText;
            })
            .catch((error) => {
                handleError(error);
            });
        if (this.agentName) {
            this.finalAgentName = this.agentName;
        } else if (this.$route.query.beratername) {
            this.finalAgentName = this.$route.query.beratername;
        }
    },
    methods: {
        submitForm() {
            this.$store.commit("setLoading", true);
            let changedFormData = { ...this.formData };
            if (this.product !== "") {
                changedFormData.nachricht =
                    this.formData.nachricht +
                    "\n\n" +
                    "Produkt des Kunden: " +
                    this.product;
            }
            if (changedFormData.rueckruf_datum !== "") {
                if (changedFormData.rueckruf_datum.charAt(2) !== ".") {
                    changedFormData.rueckruf_datum = DateFormatter.formatDate(
                        new Date(changedFormData.rueckruf_datum),
                        "YYYY-MM-DD"
                    );
                } else {
                    const dateArray = changedFormData.rueckruf_datum.split(".");
                    changedFormData.rueckruf_datum = "";
                    for (let i = dateArray.length - 1; i >= 0; i--) {
                        changedFormData.rueckruf_datum += dateArray[i];
                        if (i > 0) {
                            changedFormData.rueckruf_datum += "-";
                        }
                    }
                }
            }
            if (this.von !== "") {
                changedFormData.rueckruf_anmerkung = DateFormatter.formatDate(
                    new Date(this.von),
                    "HH:mm"
                );
            }
            if (this.bis !== "") {
                changedFormData.rueckruf_anmerkung +=
                    " - " +
                    DateFormatter.formatDate(new Date(this.bis), "HH:mm");
            }
            coachContact(this.agentId, changedFormData).then((response) => {
                if (response.data.Status === 200) {
                    if (response.data.Result) {
                        this.$ionic.alertController
                            .create({
                                header: "Erfolgreich abgesendet",
                                // message: "Möchtest du dieses Dokument wirklich löschen?",
                                buttons: [
                                    {
                                        text: "Ok",
                                        role: "cancel",
                                    },
                                ],
                            })
                            .then((a) => {
                                a.onDidDismiss().then(() => {
                                    this.$router.go(-1);
                                    this.$store.commit("setAskForRating", true);
                                });
                                a.present();
                            });
                    }
                }
            });
        },
    },
};
</script>

<style></style>
